module.exports = __webpack_public_path__ + "img/userC08.8078de93.jpg";